import { createTheme } from '@mui/material/styles';

import { components } from './lib/components';

export const appTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#e1386a',
    },
    secondary: {
      main: '#04ceff',
    },
    warning: {
      main: '#ffd04b',
    },
    background: {
      default: '#fafbfc',
      paper: '#ffffff',
    },
    text: {
      primary: '#022b3a',
      secondary: '#6f7984',
    },
    divider: '#e6e8ef',
  },
  shape: {
    borderRadius: 5,
  },
  typography: {
    fontFamily: '"Quicksand", sans-serif',
    fontSize: 15,
    h5: {
      fontFamily: '"Metropolis", sans-serif',
      fontSize: '25px',
      fontWeight: 700,
    },
    h6: {
      fontFamily: '"Metropolis", sans-serif',
      fontSize: '25px',
      fontWeight: 700,
    },
  },
  components,
});

export { components };
